import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'issue-redaction.flag.title',
		defaultMessage: 'Your organization has redacted sensitive data from this issue.',
		description: 'Message saying data is redacted from issue',
	},
	link: {
		id: 'issue-redaction.flag.link',
		defaultMessage: 'How redaction works',
		description: 'redaction link text',
	},
});
